import React from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  ReferenceLine,
} from "recharts";
import { cumulativeReturns, drawdownSeries, monthYearLabel, fullDateLabel, monthlyTicks } from "../../lib/indicators";

export default function ReturnsChart({ data }) {
  const closes = data.map((d) => Number(d.close));
  const rets = cumulativeReturns(closes);
  const dd = drawdownSeries(closes);
  const series = data.map((d, i) => ({
    raw_date: d.quote_date,
    ret: +rets[i].toFixed(3),
    dd: +dd[i].toFixed(3),
  }));
  const ticks = monthlyTicks(series, "raw_date", 6);

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <div className="space-y-2">
        <div className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground">
          Retorno acumulado · %
        </div>
        <div className="h-[200px] w-full">
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={series} margin={{ top: 5, right: 10, left: 0, bottom: 0 }}>
              <defs>
                <linearGradient id="retGrad" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="oklch(0.58 0.13 145)" stopOpacity={0.4} />
                  <stop offset="100%" stopColor="oklch(0.58 0.13 145)" stopOpacity={0} />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" stroke="oklch(0.92 0.004 286.32)" vertical={false} />
              <XAxis dataKey="raw_date" ticks={ticks} tickFormatter={monthYearLabel} interval={0} tick={{ fontSize: 10 }} stroke="oklch(0.552 0.016 285.938)" />
              <YAxis tick={{ fontSize: 10 }} stroke="oklch(0.552 0.016 285.938)" width={45} tickFormatter={(v) => `${v}%`} />
              <Tooltip
                contentStyle={{ background: "var(--popover)", border: "1px solid var(--border)", fontSize: 12 }}
                labelFormatter={fullDateLabel}
                formatter={(v) => [`${Number(v).toFixed(2)}%`, "Retorno"]}
              />
              <ReferenceLine y={0} stroke="oklch(0.552 0.016 285.938)" />
              <Area type="monotone" dataKey="ret" stroke="oklch(0.48 0.16 145)" fill="url(#retGrad)" strokeWidth={1.8} isAnimationActive={false} />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div className="space-y-2">
        <div className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground">
          Drawdown · % do pico
        </div>
        <div className="h-[200px] w-full">
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={series} margin={{ top: 5, right: 10, left: 0, bottom: 0 }}>
              <defs>
                <linearGradient id="ddGrad" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="oklch(0.55 0.21 25)" stopOpacity={0} />
                  <stop offset="100%" stopColor="oklch(0.55 0.21 25)" stopOpacity={0.4} />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" stroke="oklch(0.92 0.004 286.32)" vertical={false} />
              <XAxis dataKey="raw_date" ticks={ticks} tickFormatter={monthYearLabel} interval={0} tick={{ fontSize: 10 }} stroke="oklch(0.552 0.016 285.938)" />
              <YAxis tick={{ fontSize: 10 }} stroke="oklch(0.552 0.016 285.938)" width={45} tickFormatter={(v) => `${v}%`} />
              <Tooltip
                contentStyle={{ background: "var(--popover)", border: "1px solid var(--border)", fontSize: 12 }}
                labelFormatter={fullDateLabel}
                formatter={(v) => [`${Number(v).toFixed(2)}%`, "Drawdown"]}
              />
              <ReferenceLine y={0} stroke="oklch(0.552 0.016 285.938)" />
              <Area type="monotone" dataKey="dd" stroke="oklch(0.45 0.23 25)" fill="url(#ddGrad)" strokeWidth={1.4} isAnimationActive={false} />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
